import React, { FC } from 'react';
import { TextField } from '@ui-modules/informed';

interface IVehicleGvlpNumberField {
  defaultValue?: string;
  disabled?: boolean;
}

const VehicleGvlpNumberField: FC<IVehicleGvlpNumberField> = ({ defaultValue, disabled }) => (
  <div className="field vehicle-gvlp-number">
    <TextField
      disabled={disabled}
      initialValue={defaultValue}
      label="GVLP Number"
      max="25"
      name="gvlpNumber"
    />
  </div>
);

export default VehicleGvlpNumberField;
